import { createSlice, type PayloadAction } from "@reduxjs/toolkit"
import { staffSessionActions } from "@/store/staffSessionSlice"
import type { ObservedResource, ResourceFreshness } from "@/services/realtime/resourceRefreshCoordinator"

export const benefitReadKey = (resource: Pick<ObservedResource, "scopeKey" | "id">) => JSON.stringify([resource.scopeKey, resource.id])
interface ReadState { scopeKey: string | null; resources: Record<string, ResourceFreshness> }
const initialState: ReadState = { scopeKey: null, resources: {} }
const slice = createSlice({
  name: "benefitReads", initialState,
  reducers: {
    changed(state, action: PayloadAction<ResourceFreshness>) {
      if (state.scopeKey === action.payload.scopeKey) state.resources[benefitReadKey(action.payload)] = action.payload
    },
    removed(state, action: PayloadAction<ObservedResource>) { delete state.resources[benefitReadKey(action.payload)] },
  },
  extraReducers: builder => builder
    .addCase(staffSessionActions.scopeRevoked, () => initialState)
    .addCase(staffSessionActions.scopeEstablished, (state, action) => {
      if (state.scopeKey !== action.payload) return { scopeKey: action.payload, resources: {} }
    })
    .addCase(staffSessionActions.contextAccepted, (state, action) => {
      if (state.scopeKey !== action.payload.scopeKey) return { scopeKey: action.payload.scopeKey, resources: {} }
    }),
})
export const benefitReadActions = slice.actions
export default slice.reducer
